import { ActionTypes, useAppDispatch, useAppState } from '../Store';

// Cache for loaded language files
const languageCache = {};

export const useTranslation = () => {
    const { language } = useAppState();
    const dispatch = useAppDispatch();
   
    const lang = (language || 'en').split('-')[0];
    
    // Load language file only once and cache it
    if (!languageCache[lang]) {
        languageCache[lang] = require(`./Languages/${lang}.json`);
    }
    
    const translate = (key) => {
        // Handle nested keys with dot notation
        if (key.includes('.')) {
            const keys = key.split('.');
            let value = languageCache[lang];
            
            for (const k of keys) {
                if (value && typeof value === 'object' && k in value) {
                    value = value[k];
                } else {
                    return key; // Return the key if the path doesn't existx
                }
            }
            
            return value || key;
        }
        
        return languageCache[lang][key] || key;
    } 

    const setLanguage = (lang) => {
        localStorage.setItem('language', lang);
        dispatch({ type: ActionTypes.SET_LANGUAGE, payload: lang });
    }

    return {language, translate, setLanguage}
}